type SupabaseErrorShape = {
  code?: unknown;
  message?: unknown;
  details?: unknown;
};

function getString(value: unknown) {
  return typeof value === 'string' ? value : '';
}

export function isMissingOrganizationLifecycleColumnError(error: unknown) {
  if (!error || typeof error !== 'object') return false;

  const record = error as SupabaseErrorShape;
  const code = getString(record.code);
  const message = getString(record.message);
  const details = getString(record.details);

  return (
    code === '42703' ||
    (message.includes('lifecycle_status') && message.toLowerCase().includes('column')) ||
    (details.includes('lifecycle_status') && details.toLowerCase().includes('column'))
  );
}
